export default __webpack_public_path__ + "static/media/LTC.56eb722c.svg";